import { SessionManager } from "../SessionManager/SessionManager";

export class NetworkUtils {

    static shared = new NetworkUtils();
    
    // --------------- Request Header Utils --------------------------------

    public addCommonHeaders(headers: any) : any {
        const commonHeaders = {
            'Content-Type': 'application/json'
          }
        return {...headers, ...commonHeaders};
    }

    public addAuthHeaders(headers: any) : any {
        const authToken = SessionManager.shared.fetchJWTToken()
        const authHeader = {
            'authorization': authToken
        }

        return {...headers, ...authHeader};
    }

    public addAdminAuthHeaders(headers: any): any {
        const authToken = SessionManager.shared.getAdminAuthToken()
        const authHeader = {
            'adminAuth': authToken
        }

        return {...headers, ...authHeader};
    }
}